<template>
    <v-btn
        class="app-icon-btn"
        dark
        width="32"
        :color="color"
        :disabled="disabled"
        :small="small"
        v-bind="$attrs"
        v-on="$listeners">
        <v-icon :small="small">
            {{ icon }}
        </v-icon>
    </v-btn>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: "primary"
        },
        icon: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        }
    }
};
</script>
<style scoped>
.app-icon-btn.v-size--default {
    min-width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.125rem;
}
.app-icon-btn.v-size--small {
    min-width: 2rem;
    height: 2rem;
    border-radius: 0.125rem;
}
</style>
